import { useTranslate } from '@tolgee/react';
import styled from 'styled-components';

import FoldedHandsSvg from '../../../assets/icons/FoldedHandsSvg';
import { Center } from '../../_atoms/Center';

const Component404 = ({ message }: { message?: string }) => {
  const { t } = useTranslate();

  return (
    <Container>
      <FoldedHandsSvg />{' '}
      <h2 style={{ margin: '0 10px 0', fontWeight: 'bold' }}>
        {message ? message : t('Oops, there is nothing here')}
      </h2>
    </Container>
  );
};

export default Component404;
const Container = styled(Center)`
  height: 80%;
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
